// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".owc-header-mme__userEntry[data-v-7071a920]{display:flex;justify-content:space-between}.owc-header-mme__userEntry span[data-v-7071a920]{padding-left:var(--wb-spacing-xs);padding-right:var(--wb-spacing-xxs)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
